module.exports = __webpack_public_path__ + "static/media/arrow-right.afdaf9a4.svg";